//new siren entity property provided for executing component validation:
// validations: [
//     {
//         level: "error",//default:error ["error", "warning", "info"]
//         message: "Incorrect Mail" //grouping by message //in case one of the rules fails, the message will be displayed
//         rules : [
//             {
//                 type: "range", //[ "eMail", "range", "regexp", "alpha",  "alphanumeric", "decimal", "numeric",
//                                 // "iban", "maxsize", "lowercase", "uppercase"],
//                 //Optional properties:
//                 "range":["top": 10, "bottom":1] //"regExp":String, "range":[], "locales":[], "maxSize":Number
//             },
//              ...
//             ]
//     ...
//]
//The validation methods will be executed with priority: "error", "warning", "info"
//The required validation stays in the entity properties, but should be transform to validation rule

import Validator from "@tinqin/tinqin-utils/src/validations";
import translationService from "./TranslationService";
import internalStateService from "./InternalStateService";

const ERROR = "error";
const WARNING = "warning";
const INFO = "info";
const REQUIRED = "required";
function getValidationMethod(validations, entityProps, widgetId) {
    //validations will be grouped by level
    let validationRules = {};
    //check for required validation described
    let requiredValidation;
    //Note: Project can define custom validations and declare them to WebUI.
    let projectSpecificValidations = internalStateService.getValidations({ widgetId }) || {};
    validations.push(projectSpecificValidations);

    let errorValidations = validations.filter(validation => validation.level === ERROR);
    if (errorValidations.length) {
        validationRules[ERROR] = createValidationMethod(errorValidations, entityProps);
    }
    let warningValidations = validations.filter(validation => validation.level === WARNING);
    if (warningValidations.length) {
        validationRules[WARNING] = createValidationMethod(warningValidations, entityProps);
    }
    let infoValidations = validations.filter(validation => validation.level === INFO);
    if (infoValidations.length) {
        validationRules[INFO] = createValidationMethod(infoValidations, entityProps);
    }
    //transform required property to validation rule of error level
    //check for required validation described
    for (let key in validationRules) {
        if (validationRules[key].types.includes(REQUIRED)) {
            requiredValidation = true;
        }
    }
    let required = entityProps.required || entityProps.__required;
    let defaultRequiredMessage = translationService.translate("requiredMessage");
    let requiredMessage = entityProps.requiredMessage || defaultRequiredMessage;

    if (!requiredValidation && required) {
        if (!validationRules[ERROR]) {
            validationRules[ERROR] = {
                types: [],
                messages: {}
            };
        }
        validationRules[ERROR].types.unshift(REQUIRED);
        validationRules[ERROR].messages[REQUIRED] = requiredMessage;
    }

    return Validator.createValidationMethod(validationRules);
}

function createValidationMethod(validations, entityProps = {}) {
    let ruleTypes = [],
        ruleOptions = {},
        ruleMessages = {};

    let defaultMessage = translationService.translate("defaultValidationMessage");
    let propsErrorMessage = entityProps.validationMessage || defaultMessage;
    //check for options: if there are other properties than "type" in the rule object
    validations.forEach(validation => {
        let validationRules = validation.rules || {};
        validationRules.forEach(validationRule => {
            Object.keys(validationRule).forEach(prop => {
                let validationProperty = validationRule[prop];
                if (prop === "type") {
                    ruleTypes.push(validationProperty);
                    ruleMessages[validationProperty] = validation.message || propsErrorMessage;
                } else {
                    ruleOptions[prop] = validationProperty;
                }
            });
        });
    });

    return { types: ruleTypes, messages: ruleMessages, options: ruleOptions };
}

export default {
    getValidationMethod
};
